import React from "react";
import ColorConstants from "constants/ColorConstants";
import { ButtonToolbar, Button, Checkbox } from 'ui';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import { Scrollbars } from "react-custom-scrollbars";

const dropDownContentStyle = {
  borderColor: ColorConstants.LIGHT_GREY,
  backgroundColor: "white",
  minWidth: "160px",
  width: "300px",
  boxShadow: "2px 2px 2px 2px rgba(0,0,0,0.2)",
  borderRadius: "3px",
  maxHeight: "500px",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
};

const ChecklistDropdown = ({
  codes = [],
  subHeader,
  onDeleteFilter,
  onClearChecked,
  onDoneButton,
  filterButtonText,
  onChecked,
  ariaLabel,
}) => {
  const getCodeName = (code) => (code.count ? `${code.name} (${code.count})` : code.name);

  const checkLists = (codes || []).map((code) => (
    <Checkbox
      key={code.id}
      checked={code.checked}
      onChange={() => onChecked(code.id, code.checked)}
    >
      {getCodeName(code)}
    </Checkbox>
  ));

  return (
    <div style={dropDownContentStyle} aria-label={ariaLabel}>
      <div style={{ padding: "10px", width: "100%", display: "flex", flexDirection: "column", height: "100%" }}>
        <Scrollbars autoHide autoHeight autoHeightMin={100} autoHeightMax={400}>
          <div style={{ color: ColorConstants.LIGHT_GREY }}>
            <em>{subHeader || "Filter snippets by any of the selected"}</em>
          </div>
          {checkLists}
        </Scrollbars>
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", paddingTop: 10, flexShrink: 0 }}>
          <ButtonToolbar>
            {onDeleteFilter && (
              <Button variant="link" onClick={onDeleteFilter}>
                <DeleteOutlineIcon data-testid="DeleteOutlinedIcon" style={{ fontSize: 16 }} />
              </Button>
            )}
            {onClearChecked &&
              <Button variant="white" onClick={onClearChecked}>
                Clear
              </Button>
            }
            {onDoneButton &&
              <Button variant="blue" onClick={onDoneButton}>
                {filterButtonText || "Apply Filters"}
              </Button>
            }
          </ButtonToolbar>
        </div>
      </div>
    </div>
  );
};

export default ChecklistDropdown;
